import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { FeatureFlag, useFeatureFlagResolved } from '../services/featureFlag.service';

// Route-level gate for Ruthie (the Data Architect agent). The sidebar nav link
// is already hidden when the flag is off, but a direct URL load still needs to
// be guarded. Wait for the flag to resolve before redirecting so a cold
// direct-URL load doesn't bounce users home before LaunchDarkly reports in.
export default function RuthieGuard({ children }: PropsWithChildren) {
  const { value: isRuthieEnabled, isLoading } = useFeatureFlagResolved(FeatureFlag.RUTHIE, false);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isRuthieEnabled) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
